/**
 * BACK-02/03/08/11/14 — ponte entre o Router e o `overlayManager`. Montada uma vez dentro do
 * `<Router>` (em `App.tsx`, antes de `AppRoutes`): instala o listener de `popstate` em captura
 * (pops de overlay/fantasma não chegam ao Router) e o de Esc (BACK-15), informa a troca de rota (`location.key`) e
 * limpa entradas de overlay deixadas por um reload.
 *
 * Os listeners ficam instalados pela vida do módulo (o gerenciador também os instala no
 * primeiro `register`), por isso não há cleanup — o StrictMode não os duplica.
 */
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { ensureOverlayKeyboard } from './overlayKeyboard'
import { overlayManager, type OverlayManager } from './overlayManager'

export interface OverlayHistoryBridgeProps {
  /** Injeção para testes; padrão = singleton. */
  manager?: OverlayManager
}

export function OverlayHistoryBridge({ manager = overlayManager }: OverlayHistoryBridgeProps) {
  const { key } = useLocation()

  useEffect(() => {
    manager.handleRouteChange(key)
  }, [manager, key])

  useEffect(() => {
    manager.connect()
    ensureOverlayKeyboard(manager)
    manager.bootstrap()
  }, [manager])

  return null
}
